import { useContext } from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import { ThemeContext } from "../../App";
import './Home.scss';
import StakingImg from '../../assets/img/info_bg.png';

import CeoImg from '../../assets/img/ceo.jpg';
import SellerImg from '../../assets/img/marketer.png';
import DeveloperImg from '../../assets/img/cto.png';
import MainBg from '../../assets/img/main_bg.jpg';
import SecondBg from '../../assets/img/main_bg_old.png';
import FaqPage from "./FaqPage";
import Roadmap from "./Roadmap";

function Home() {
    let { theme } = useContext(ThemeContext);
    return <div id="home">
        <div className="caption-block">
            <img src={MainBg} />
            <div className="p-2"></div>
            <img src={SecondBg} />
        </div>
        <div id="info" className="pt-5 pb-5">
            <Container>
                {/* <h1 className="mb-2 text-center text-white page-title mb-5">Welcome to Solporate</h1> */}
                {/* <h2 className="text-white mb-5">Choose a Sub-DAO and participate in DAO War!</h2> */}
                {/* <h2 className="text-center ml-5 title">Information</h2> */}
                {/* <p className="summary mb-5">Solporate is a company in the Solana blockchain. Solporate employs 2,722 cats and is branched out to 3 regions - Solporate Valley, Las Catas, and Meow York. Solporate cats are sent on a business trip to 1 of the regions. Make sure to choose wisely as some cities are are more dangerous than others.</p> */}
                {/* <div className="mb-5 utility">
                    <img src={UtilityImg} />
                </div> */}
                <div className="mb-2 staking">
                    <img src={StakingImg} />
                </div>
            </Container>
        </div>
        <div id="roadmap" className="pt-5 pb-5">
            <Roadmap />
        </div>
        <div id="team" className="p-5">
            <Container>
                <h2 className="text-center ml-5 title">Team</h2>
                <Row className="mt-5">
                    <Col>
                        <div className="team-item p-3">
                            <img src={CeoImg} className="rounded-circle" />
                            <h4 className="pt-3 name">Neo</h4>
                            <p className="text-italic bio">Project Lead</p>
                        </div>
                    </Col>
                    <Col>
                        <div className="team-item p-3">
                            <img src={SellerImg} className="rounded-circle" />
                            <h4 className="pt-3 name">Jped</h4>
                            <p className="text-italic bio">Sales and Marketing</p>
                        </div>
                    </Col>
                    <Col>
                        <div className="team-item p-3">
                            <img src={DeveloperImg} className="rounded-circle" />
                            <h4 className="pt-3 name">Yaroslav</h4>
                            <p className="text-italic bio">Lead Developer</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        <FaqPage></FaqPage>
    </div>
}

export default Home;